// @mui
import {
  Stack,
  IconButton,
} from "@mui/material";
// hooks
import useResponsive from '../../../../hooks/useResponsive';
// components
import Iconify from '../../../../components/Iconify';


export default function PasteJobPostHeader({step, goStep, isEdit, close}) {
  const smUp = useResponsive('up', 'sm');

  const closeOrGoStep = () => {
    if (step === 3) {
      close()
    } else {
      goStep(step-1)
    }
  }

  return (
    <>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ mb: smUp ? 6 : 2 }}>
        <IconButton color="inherit" edge="start" onClick={closeOrGoStep} sx={{ ...((step === 3 || isEdit) && {visibility: 'hidden' }) }}>
          <Iconify icon="ic:chevron-left" sx={{ width: smUp ? 32 : 24 , height: smUp ? 32 : 24, color: (theme) => theme.palette.primary.main }} />
        </IconButton>
        <IconButton color="inherit" edge="end" onClick={close}>
          <Iconify icon="ic:round-close" sx={{ width: smUp ? 32 : 24 , height: smUp ? 32 : 24, color: (theme) => theme.palette.text.disabled }} />
        </IconButton>
      </Stack>
    </>
  )
}
